/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/* plugins/segments-intelligence/assets/js/seg-intel.js — Segments Intelligence viewer.
   Read-only: dimensions + segment sizes come from /plugin/segments-intelligence/*, which reads the
   core's own session data. Phase 1 ships device / browser / OS / country; the dimension bar is driven
   by the /dimensions endpoint so later phases (ISP/ASN, VPN, region, cohorts) appear with no edit here. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["segments-intelligence"] = "1.4.1"; } catch (e) {}

  var STATE = { dim: "device", from: null, to: null };
  var DIMS = [];
  var LAST = null, CP_OPEN = false, CP_NET = null, CP_INT = null;   // Co-Pilot: last view + cached cross-signals

  function q(k) { return document.querySelector('[data-si="' + k + '"]'); }
  function qa(s) { return Array.prototype.slice.call(document.querySelectorAll(s)); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function nf(n) { return (n == null ? 0 : n).toLocaleString(); }
  function site() { return (window.GS && GS.site) || ""; }

  function api(action, extra) {
    var qs = "?site=" + encodeURIComponent(site());
    if (STATE.from) qs += "&from=" + STATE.from;
    if (STATE.to) qs += "&to=" + STATE.to;
    return GS.api("/plugin/segments-intelligence/" + action + qs + (extra || ""));
  }

  function defaultRange() {
    var to = new Date(), from = new Date(); from.setDate(from.getDate() - 29);
    STATE.to = to.toISOString().slice(0, 10); STATE.from = from.toISOString().slice(0, 10);
    var f = q("from"), t = q("to"); if (f) f.value = STATE.from; if (t) t.value = STATE.to;
  }

  function _rpT(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function _rpYmd(d){return d.getUTCFullYear()+"-"+("0"+(d.getUTCMonth()+1)).slice(-2)+"-"+("0"+d.getUTCDate()).slice(-2);}
  function _rpToday(){var n=new Date();return new Date(Date.UTC(n.getUTCFullYear(),n.getUTCMonth(),n.getUTCDate()));}
  function _rpPreset(days){var to=_rpToday(),from=new Date(to.getTime()-(days-1)*86400000);var lbl={7:_rpT("an.last7"),30:_rpT("an.last30"),90:_rpT("an.last90"),365:_rpT("an.last12mo")}[days]||(days+" days");return {from:_rpYmd(from),to:_rpYmd(to),label:lbl,preset:String(days)};}
  var _RPL={label:null,preset:"30"};
  (function(){try{var s=JSON.parse(localStorage.getItem("gs_si_range")||"null");if(s&&s.preset){var p=_rpPreset(+s.preset);STATE.from=p.from;STATE.to=p.to;_RPL.label=p.label;_RPL.preset=p.preset;}else if(s&&s.from&&s.to){STATE.from=s.from;STATE.to=s.to;_RPL.label=s.from+" \u2192 "+s.to;_RPL.preset=null;}}catch(e){}if(!_RPL.label){var d=_rpPreset(30);STATE.from=d.from;STATE.to=d.to;_RPL.label=d.label;}})();
  function _rpInit(){
    function _rpBtnLabel(menu,preset){if(!menu||!preset)return null;var b=menu.querySelector('.rm[data-preset="'+preset+'"]');return b?b.textContent.trim():null;}
    
    if(_RPL&&_RPL.preset){var _rp=_rpPreset(+_RPL.preset);_RPL.label=_rp.label;if(typeof RANGE!=="undefined"&&RANGE){RANGE.label=_rp.label;}}
    var btn=q("rangeBtn"),menu=q("rangeMenu"),lab=q("range-label");if(!btn||!menu)return;
    (function(){var _pp=(typeof RANGE!=="undefined"&&RANGE&&RANGE.preset)||(typeof _RPL!=="undefined"&&_RPL&&_RPL.preset);var _bl=_rpBtnLabel(menu,_pp);if(_bl){if(lab)lab.textContent=_bl;if(typeof RANGE!=="undefined"&&RANGE)RANGE.label=_bl;if(typeof _RPL!=="undefined"&&_RPL)_RPL.label=_bl;}})();
    var hf=q("from"),ht=q("to");if(hf)hf.value=STATE.from;if(ht)ht.value=STATE.to;
    if(lab&&_RPL.label)lab.textContent=_RPL.label;
    function sync(){menu.querySelectorAll(".rm[data-preset]").forEach(function(x){x.classList.toggle("on",x.getAttribute("data-preset")===_RPL.preset);});}
    btn.addEventListener("click",function(e){if(menu.contains(e.target)&&e.target!==btn)return;e.stopPropagation();var open=menu.style.display!=="none";menu.style.display=open?"none":"block";if(!open){var cf=menu.querySelector('[data-rp="from"]'),ct=menu.querySelector('[data-rp="to"]');if(cf)cf.value=STATE.from;if(ct)ct.value=STATE.to;sync();}});
    document.addEventListener("click",function(e){if(!btn.contains(e.target))menu.style.display="none";});
    function apply(o){ if(o&&o.preset){var _bl2=_rpBtnLabel(menu,o.preset);if(_bl2)o.label=_bl2;}STATE.from=o.from;STATE.to=o.to;_RPL.label=o.label;_RPL.preset=o.preset;if(hf)hf.value=o.from;if(ht)ht.value=o.to;if(lab)lab.textContent=o.label;try{localStorage.setItem("gs_si_range",JSON.stringify({from:o.from,to:o.to,preset:o.preset}));}catch(e){}menu.style.display="none";load();}
    menu.querySelectorAll(".rm[data-preset]").forEach(function(b){b.addEventListener("click",function(){apply(_rpPreset(+b.getAttribute("data-preset")));});});
    var ap=menu.querySelector('[data-rp="apply"]');if(ap)ap.addEventListener("click",function(){var ff=menu.querySelector('[data-rp="from"]').value,tt=menu.querySelector('[data-rp="to"]').value;if(!ff||!tt)return;if(ff>tt){var x=ff;ff=tt;tt=x;}apply({from:ff,to:tt,label:ff+" \u2192 "+tt,preset:null});});
  }
  function dimLabel(k) { for (var i = 0; i < DIMS.length; i++) if (DIMS[i].key === k) return DIMS[i].label; return k; }

  function renderDims() {
    var host = q("dims"); if (!host) return;
    if (!DIMS.length) { host.innerHTML = '<span class="gs-muted small">'+TR('segmen.f2.no_dimensions_available')+'</span>'; return; }
    var groups = [], byG = {};
    DIMS.forEach(function (d) { var g = d.group || "Other"; if (!byG[g]) { byG[g] = []; groups.push(g); } byG[g].push(d); });
    host.innerHTML = groups.map(function (g) {
      return '<div class="si-dimg"><span class="si-dimg-l">' + esc(g) + "</span>" +
        byG[g].map(function (d) {
          return '<button type="button" class="si-dim' + (STATE.dim === d.key ? " on" : "") + '" data-dim="' + esc(d.key) + '">' + esc(d.label) + "</button>";
        }).join("") + "</div>";
    }).join("");
    qa('[data-dim]').forEach(function (b) {
      b.addEventListener("click", function () { STATE.dim = b.getAttribute("data-dim"); renderDims(); load(); });
    });
  }

  function activeDim() { for (var i = 0; i < DIMS.length; i++) if (DIMS[i].key === STATE.dim) return DIMS[i]; return {}; }

  function renderList(d) {
    var host = q("list"); if (!host) return;
    var segs = (d && d.segments) || [];
    var ad = activeDim();
    var lt = q("list-title"); if (lt) lt.textContent = TR('segmen.g.segments_by') + dimLabel(STATE.dim).toLowerCase();
    var sub = q("list-sub"); if (sub) sub.textContent = segs.length ? segs.length + " segment" + (segs.length === 1 ? "" : "s") : "";
    var help = q("dimhelp"); if (help) help.textContent = ad.help || "";
    var tot = q("totals");
    if (tot) tot.textContent = d && d.total_visitors != null ? nf(d.total_visitors) + " visitors \u00b7 " + nf(d.total_sessions) + " sessions in range" : "";
    var dep = q("depnote"); if (dep) dep.hidden = !(d && d.total_visitors === 0);

    if (!segs.length) { host.innerHTML = '<div class="si-empty">No ' + esc(dimLabel(STATE.dim).toLowerCase()) + " recorded for anyone in this range.</div>"; return; }
    var canCompare = !!ad.compare;                 // Compare Mode can filter device/country today
    host.classList.toggle("si-list--act", canCompare);
    var max = segs[0].pct || 1;
    host.innerHTML = segs.map(function (s) {
      var w = Math.max(2, Math.round((s.pct / (max || 1)) * 100));
      var tile = canCompare
        ? '<a class="si-cmp" href="/compare-mode?' + encodeURIComponent(STATE.dim) + "=" + encodeURIComponent(s.key) +
          '" title="Compare \u2018' + esc(s.key) + '\u2019 against the rest in Compare Mode"><i class="bi bi-bar-chart-steps"></i></a>'
        : (DIMS.some(function (x) { return x.compare; }) ? '<span class="si-cmp-x"></span>' : "");
      return '<div class="si-row" title="' + esc(s.key) + " \u2014 " + nf(s.visitors) + " visitors, " + nf(s.sessions) + ' sessions">' +
        '<span class="si-k">' + esc(s.key) + "</span>" +
        '<span class="si-bar"><i style="width:' + w + '%"></i></span>' +
        '<span class="si-v">' + nf(s.visitors) + '</span>' +
        '<span class="si-pct">' + s.pct + "%</span>" + tile + "</div>";
    }).join("");
    LAST = d; if (CP_OPEN) cpRender();
  }

  /* ---- Segments Co-Pilot: a plain-language read of the current segmentation, in the same
     paragraphs / observations / actions shape as the dashboard Co-Pilot. Rule-based on the loaded
     data plus two cross-cutting signals (network risk, intent warmth) — no external calls. ---- */
  function has(dim) { for (var i = 0; i < DIMS.length; i++) if (DIMS[i].key === dim) return true; return false; }
  function pctSum(segs, n) { var s = 0, m = Math.min(n, segs.length); for (var i = 0; i < m; i++) s += segs[i].pct; return s; }

  function cpToggle() {
    CP_OPEN = !CP_OPEN;
    var p = q("copilot"); if (p) p.hidden = !CP_OPEN;
    var b = q("cpBtn"); if (b) b.classList.toggle("on", CP_OPEN);
    if (CP_OPEN) cpRender();
  }
  function fetchSig(dim, slot) {
    return api("segments", "&dim=" + dim).then(function (r) { var d = r && r.data ? r.data : r; if (slot === "net") CP_NET = d; else CP_INT = d; })
      .catch(function () { if (slot === "net") CP_NET = {}; else CP_INT = {}; });
  }
  function cpRender() {
    var body = q("cp-body"); if (!body) return;
    cpPaint(body, buildCopilot());
    var need = [];
    if (has("network") && CP_NET === null) need.push(fetchSig("network", "net"));
    if (has("intent") && CP_INT === null) need.push(fetchSig("intent", "int"));
    if (need.length) Promise.all(need).then(function () { if (CP_OPEN) cpPaint(body, buildCopilot()); });
  }
  function buildCopilot() {
    var out = { paragraphs: [], observations: [], actions: [] };
    var d = LAST;
    if (!d || !d.segments || !d.segments.length) { out.paragraphs.push(TR('segmen.f3.load_a_dimension_and_i_u2019ll_rea')); return out; }
    var ad = activeDim(), label = (ad.label || STATE.dim).toLowerCase(), top = d.segments[0];
    var p1 = "By " + label + ", your biggest group is \u201c" + top.key + "\u201d \u2014 " + top.pct + "% of visitors (" + nf(top.visitors) + "). ";
    p1 += d.segments.length >= 3 ? "The top three cover " + pctSum(d.segments, 3) + "% between them."
        : (d.segments.length === 1 ? TR('segmen.p.it_u2019s_the_only_group_here') : "There are only " + d.segments.length + " groups here.");
    out.paragraphs.push(p1);
    if (top.pct >= 60) out.observations.push("\u201c" + top.key + "\u201d dominates at " + top.pct + "% \u2014 anything you improve for them moves the most people.");
    else if (d.segments.length >= 6 && pctSum(d.segments, 3) < 50) out.observations.push("A long tail \u2014 no single " + label + " owns the audience, so broad changes beat niche ones.");

    if (CP_NET && CP_NET.segments) {
      var anon = 0; CP_NET.segments.forEach(function (s) { if (/VPN|Proxy|Tor|Datacenter/i.test(s.key)) anon += s.pct; });
      if (anon > 0) {
        out.paragraphs.push(anon + "% of visitors arrived over datacenter, VPN, proxy or Tor networks. " +
          (anon >= 25 ? "That\u2019s high \u2014 check for bots or scraping before trusting conversion numbers." : TR('segmen.f3.mostly_residential_otherwise_u2014')));
        if (anon >= 25) out.observations.push("Elevated non-residential share (" + anon + "%) \u2014 filter bots before reading conversions.");
      }
    }
    if (CP_INT && CP_INT.segments) {
      var hi = 0; CP_INT.segments.forEach(function (s) { if (/High intent/i.test(s.key)) hi += s.pct; });
      if (hi > 0) out.paragraphs.push(hi + "% of scored visits showed high intent \u2014 that\u2019s your warm audience to prioritise.");
    }
    if (ad.compare) out.actions.push({ label: "Compare \u201c" + top.key + "\u201d in Compare Mode", href: "/compare-mode?" + encodeURIComponent(STATE.dim) + "=" + encodeURIComponent(top.key) });
    return out;
  }
  function cpPaint(body, r) {
    if (!body) return;
    var html = (r.paragraphs || []).map(function (p) { return '<p class="si-cp-p">' + esc(p) + "</p>"; }).join("");
    if (r.observations && r.observations.length) html += '<div class="si-cp-sec">'+TT('segm.js.what_stands_out')+'</div>' +
      r.observations.map(function (o) { return '<div class="si-cp-obs"><i class="bi bi-lightbulb"></i><span>' + esc(o) + "</span></div>"; }).join("");
    if (r.actions && r.actions.length) html += '<div class="si-cp-sec">'+TT('segm.js.next_steps')+'</div>' +
      r.actions.map(function (a) { return '<a class="si-cp-act" href="' + esc(a.href) + '">' + esc(a.label) + ' <i class="bi bi-arrow-right"></i></a>'; }).join("");
    body.innerHTML = html || '<p class="si-cp-p">'+TR('segmen.f2.nothing_scored_in_this_range_yet')+'</p>';
  }

  function load() {
    if (!site()) return;
    api("segments", "&dim=" + encodeURIComponent(STATE.dim)).then(function (r) {
      renderList(r && r.data ? r.data : r);
    }).catch(function () {
      var host = q("list"); if (host) host.innerHTML = '<div class="si-empty">Couldn\u2019t load segments.</div>';
    });
  }

  function loadDims() {
    api("dimensions").then(function (r) {
      var d = r && r.data ? r.data : r;
      DIMS = (d && d.dimensions) || [];
      if (DIMS.length && !DIMS.some(function (x) { return x.key === STATE.dim; })) STATE.dim = DIMS[0].key;
      renderDims(); load();
    }).catch(function () {
      DIMS = [{ key: "device", label: TR("segmen.device") }, { key: "browser", label: TR("segmen.browser") }, { key: "os", label: TR("segmen.operating_system") }, { key: "country", label: TR("segmen.country") }];
      renderDims(); load();
    });
  }

  function init() {
    defaultRange(); _rpInit();
    var f = q("from"), t = q("to");
    if (f) f.addEventListener("change", function () { STATE.from = f.value; CP_NET = CP_INT = null; load(); });
    if (t) t.addEventListener("change", function () { STATE.to = t.value; CP_NET = CP_INT = null; load(); });
    var cb = q("cpBtn"); if (cb) cb.addEventListener("click", cpToggle);
    loadDims();
  }

  document.addEventListener("gs:ready", init);
  /* Retired the bespoke inline panel; feed the same read into the shared Co-Pilot off-canvas. */
  document.addEventListener("gs:ready", function () {
    if (window.GSCopilot) window.GSCopilot.register("segments-intelligence", function () { return buildCopilot(); });
  });
  document.addEventListener("gs:site-change", function () { CP_NET = CP_INT = null; load(); });
  if (window.GS && GS.site) init();
})();
